const DECO_SCHEDULES = ["U.S. Navi Diving Manual Revision 7", "DCIEM Diving Manual", "Other"];

export default DECO_SCHEDULES;
